module.exports = __webpack_public_path__ + "img/logo-3.4625582a.png";